<template>
  <div class="resource-card">
    <div class="resource-card__wrapper">
      <h2 class="resource-card__title">
        <a :href="resource.file.url" v-if="resource.file && !resource.subresources" target="_blank">{{ resource.name }}</a>
        <template v-else>{{ resource.name }}</template>
      </h2>

      <a v-if="resource.file && !resource.subresources" :href="resource.file.url" download class="btn">
        Download PDF
        <FontAwesomeIcon :icon="arrow" />
      </a>
    </div>
    <ul class="resource-card__subresources" v-if="resource.subresources?.length">
      <li v-for="subresource in resource.subresources" :key="subresource.name.toLowerCase().replace(/ /g, '-')">
        <ResourceCard :resource="subresource" />
      </li>
    </ul>
  </div>
</template>

<script>
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
export default {
  name: 'ResourceCard',
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      arrow: faArrowDown
    }
  }
};
</script>
